import { MfsLogo } from "@App/Components/atoms/whitelabel/logos/MfsLogo";
import { NissanFSLogo } from "@App/Components/atoms/whitelabel/logos/NissanFSLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import { config as defaultConfig } from "@App/configs/default";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the MFS whitelabel.
 * Extends the default configuration with specific settings for MFS.
 */
export const config: Partial<Config> = {
  slug: "mfs",
  navbar: {
    logos: {
      right: {
        component: (
          <div className={"flex items-center gap-3"}>
            <MfsLogo />
            <NissanFSLogo />
          </div>
        ),
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mobilize-fs.de/",
    },
  },
  reviews: {
    show: true,
  },
  garageList: {
    ...defaultConfig.garageList,
    disableFetchLocationOnLoad: true,
  },
};

export default config;
